
export class AloDataPoolItem {       

    public dtaId: number|null
    public usrId: number|null
    public dtaKey: string
    public dtaValue: string
    public dtaNote: string

    constructor({dtaId = null,usrId=null,dtaKey="",dtaValue="",dtaNote=""} = {}) {        
        this.dtaId = dtaId
        this.usrId = usrId
        this.dtaKey = dtaKey
        this.dtaValue = dtaValue
        this.dtaNote = dtaNote
    }

    static createAloDataPoolItem(data:any) {
        return new AloDataPoolItem(data)
    }
    
    static createAloDataPoolItemArray(datas:Array<any>) {
        return datas.map(d => new AloDataPoolItem(d))
    }
    
    static createReadOnlyAloDataPoolItem(data:any) {
        return Object.freeze(new AloDataPoolItem(data))
    }
}
